<ng-container *ngIf="!hide">
    <app-header [isVendor]="isVendor" [isAboutus]="isAboutus"></app-header>
</ng-container>
<router-outlet></router-outlet>
<ng-container *ngIf="!hide">
    <app-footer></app-footer>
</ng-container>